import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { PestGallery } from './components/PestGallery';
import { BusinessSection } from './components/BusinessSection';
import { Testimonials } from './components/Testimonials';
import { ContactForm } from './components/ContactForm';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppBubble } from './components/WhatsAppBubble';
const PAGE_TITLE = 'Mobal Fumigaciones | El fin de las plagas';
const PAGE_DESCRIPTION = 'Fumigaciones profesionales para casas y empresas en Rosario y alrededores.';
const OG_IMAGE = 'https://cdn.magicpatterns.com/uploads/sTBYKR7U6bMKUaUtjJjf8a/WhatsApp_Image_2026-04-23_at_00.43.05.jpg';
function setMetaTag(property: string, content: string, isName = false) {
  const attr = isName ? 'name' : 'property';
  let tag = document.querySelector(`meta[${attr}="${property}"]`) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, property);
    document.head.appendChild(tag);
  }
  tag.content = content;
}
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    setMetaTag('description', PAGE_DESCRIPTION, true);
    setMetaTag('og:title', PAGE_TITLE);
    setMetaTag('og:description', PAGE_DESCRIPTION);
    setMetaTag('og:image', OG_IMAGE);
    setMetaTag('og:type', 'website');
    setMetaTag('og:locale', 'es_AR');
    setMetaTag('twitter:card', 'summary_large_image', true);
    setMetaTag('twitter:title', PAGE_TITLE, true);
    setMetaTag('twitter:description', PAGE_DESCRIPTION, true);
    setMetaTag('twitter:image', OG_IMAGE, true);
  }, []);
  return <div className="min-h-screen bg-mobal-black text-mobal-white font-body selection:bg-mobal-green selection:text-mobal-black" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <PestGallery data-id="element-5" />
        <BusinessSection data-id="element-6" />
        <Testimonials data-id="element-7" />
        <ContactForm data-id="element-8" />
        <FAQ data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
      <WhatsAppBubble data-id="element-12" />
    </div>;
}